import {Injectable} from '@angular/core';
import {Http} from '@angular/http';
import {Observable} from 'rxjs/Observable';
import {HttpRequestService} from '../_common/http-request.service';

@Injectable()
export class CategoryMoneyService {

    constructor(private http: HttpRequestService) {
    }

    gets(parameters: any) {
        return this.http.get(`categoryMoney`, parameters)
            .map(res => {
                return res.json();
            })
    }

    add(model: any) {
        return this.http.post(`addCategoryMoney`,
            model).map(res => {
            return res.json();
        });
    }

    edit(model: any) {
        return this.http.put(`editCategoryMoney`,
            model).map(res => {
            return res.json();
        });
    }

    get(id) {
        return this.http.get(`getCategoryMoneyById?id=${id}`)
            .map(res => {
                return res.json();
            })
    }

    delete(id: string) {
        return this.http.delete(`deleteCategoryMoney?id=${id}`)
            .map(res => {
                return res.json();
            });
    }

    getAll() : Observable<any[]>{
        return this.http.get(`getAll`)
            .map(res => {
                return res.json()
            });
    }
}



// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_services/category-money.service.ts